import React from "react";

import triadsReference from '../../../assets/images/RootTriadsPiano.gif';

class PianoTriadChordReference extends React.Component {
    constructor() {
        super();
    }

    render() {

        return (
            <div>
                <h1>Root Triad Chords on the Piano Reference</h1>
                This chart shows all root Major, Minor, and Diminished triad
                chords on the piano for all Major and Minor scales.
                <br/>
                <br/>
                The major scale listing on the left is always accompanied by its corresponding
                minor scale listing on the right. The related minor scale contains all of the same
                notes but minor chords are emphasized at the root position of the minor scale.
                <br/><br/>
                <img src={triadsReference} alt={"Triad chord reference of major and minor scales" }/><br/><br/>
            </div>
        )
    }
}
export default PianoTriadChordReference;
